import { CaretDownOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Dropdown,
  Input,
  message,
  Row,
  Space,
  Switch,
  Table,
} from "antd";
import Meta from "../../../Meta";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SET_DATA_TYPE } from "../../../common/actionTypes";
import {
  AUTO_PROVISIONING_CLIENT,
  MetaTitle,
} from "../../../common/constants/constants";
import actions from "../../../redux/actions";
import { service } from "../../../services";
import "./falcon-table.scss";
import "./falcon.scss";
import JobDetails from "../commonComponent/JobDetails";

const Falcon = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [viewLogsOpen, setViewLogs] = useState(false);
  const [conditionsList, setConditionsList] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const dataFetchedRef = useRef(false);
  const [page, setPage] = useState(1);
  const datatype = useSelector((state) => state?.auth?.datatype);
  const [jobType, setJobType] = useState();
  const [jobName, setJobName] = useState("");
  const [dataType, setDataType] = useState("");
  const [provision, setProvision] = useState("");
  const [pagination, setPagination] = useState({
    current: page,
    size: 10,
    total: 0,
  });
  const [provisionList, setProvisionList] = useState([]);
  const [provisionDataTypeList, setProvisionDataTypeList] = useState([]);

  useEffect(() => {
    if (dataFetchedRef.current) {
      dataFetchedRef.current = false;
      return;
    } else {
      dataFetchedRef.current = true;
    }
  }, [datatype]);

  const getConditions = async (pageNo = page) => {
    setLoader(true);
    let client = provision ? provision : AUTO_PROVISIONING_CLIENT.FALCON;
    let payload = {
      page: pageNo,
      size: 10,
      searchBy: searchText ||  "",
      datatype: dataType,
    };
    service.getConditionsList(payload, client).then((respo)=>{
      setLoader(false);
      if (respo.success) {
        setPagination({
          total: respo.data.totalCount,
          current: respo.data.page,
          size: 10,
        });
        setConditionsList(respo.data.data);
      } 
    })
    
  };

  const handlecondition = (id, name) => {
    navigate(`/auto-provisioning/falcon/${id}`, { state: {name,provision} });
  };

  const columns = [
    {
      title: "",
      dataIndex: "",
      width: "2%",
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "20%",
      render: (value, row) => (
        <>
          <div
            style={{ cursor: "pointer", color: "#667AFF" }}
            className="condition-edit-btn"
            onClick={() => handlecondition(row?.id, row.name)}
            shape="circle"
            size="small"
          >
            {row.name}
          </div>
        </>
      ),
    },
    {
      title: "Identification Id",
      dataIndex: "indentificationId",
      width: "20%",
    },
    {
      title: "Created By",
      width: "15%",
      render: (value, row) => 
      <>
          {row.createdBy?.firstName ? 
            <div>
              {row.createdBy?.firstName+" "+row.createdBy?.lastName}
            </div>
            :
            <div style={{marginLeft: '25px'}}>
              -
            </div>
          }
        </>
    },
    {
      title: "Updated By",
      width: "15%",
      render: (value, row) => 
      <>
       {row.updatedBy?.firstName ? 
        <div>
          {row.updatedBy?.firstName+" "+row.updatedBy?.lastName}
        </div>
        :
        <div style={{marginLeft: '25px'}}>
          -
        </div>
       }
      </>,
    },
    {
      title: "Last Updated",
      width: "15%",
      render: (value, row) => <div>{row.updatedAt}</div>,
    },
    {
      title: "Pushing Data",
      dataIndex: "action",
      width: "10%",
      render: (value, row) => (
        <>
          <Switch
            size="small"
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            checked={row?.enablePushingData === true ? true : false}
            onChange={() => changeConditionStatus(row)}
          />
        </>
      ),
    },
  ];

  useEffect(()=> {
    getProvisionType();
  },[]);

  useEffect(()=> {
    if(provision && dataType){
      getConditions();
    }
  },[page, dataType]);
  
  const changeConditionStatus = async (row) => {
    let payload = {
      id: row.id,
      enablePushingData: row.enablePushingData === true ? false : true,
    };
    let response = await service.createOrUpdateCondition(payload, provision);
    if (response?.success) {
      getConditions();
      message.success(response?.data?.message);
    } else {
      console.error(
        "Error while creating new condition",
        response?.data?.message
      );
    }
  };

  useEffect(() => {
    if(provision){
      actions.getFilterList(provision);
    }
  }, [provision]);

  useEffect(() => {
    let timeout;
    if(searchText != null){
      timeout = setTimeout(()=>{
        setPage(1);
        getConditions(1);
      }, 600)
    }
    return ()=>clearInterval(timeout)
  }, [searchText]);

  const handleMenuClick = (e) => {
    setPage(1);
    let type = provisionDataTypeList?.find((x) => x?.key == e?.key);
    if (type) {
      setJobType(type?.jobType);
      setJobName(type?.jobName);
      setDataType(type?.key);
      dispatch({
        type: SET_DATA_TYPE,
        payload: type,
      });
    }
  };

  const handleprovisionClick = (e) => {
    setProvision(e?.key);
    getProvisionDataType(e?.key);
    localStorage.setItem('Provision', e?.key);
    setPage(1);
  };

  const getProvisionType = async () => {
    setProvisionList([]);
    let respo = await service.getProvisionTypes();
    if (respo.success) {
      let  list=[];
      respo.data.map((data) => {
        list.push({"key": data.provisioningType, "label": data.provisioningType})
      });
      setProvisionList(list);
      let provision = localStorage.getItem('Provision') || list[0]?.key;
      setProvision(provision);
      getProvisionDataType(provision);
    } else {
      console.log("error", respo.message);
    }
  };

  const getProvisionDataType = async (dataType) => {
    setProvisionDataTypeList([]);
    setDataType(null);
    setLoader(true);
    let respo = await service.getProvisionDataType(dataType);
    if (respo.success) {
      let  list=[];
      respo.data.map((data) => {
        list.push(
          {
            "key": data.dataType, 
            "label": data.dataType,
            "jobName":data.jobName,
            "jobType":data.jobType
          })
      });
      setProvisionDataTypeList(list);
      setJobName(list[0].jobName);
      let provisionData = list?.find((x)=> x?.key == datatype?.key);// to maintain the state
      let dataTypeTemp = provisionData ? provisionData : list[0];
      setDataType(dataTypeTemp?.key);
      dispatch({
        type: SET_DATA_TYPE,
        payload: dataTypeTemp,
      });
      setJobType(list[0].jobType);
    } else {
      console.log("error", respo.message);
    }
  };
  useEffect(function(){
    localStorage?.setItem("cronJobName",jobName)
  },[jobName])
  return (
    <>
      <Meta name={MetaTitle.Falcon} />
      <Row>
        <Col span={24}>
          <h1 className="page-container-title-pixie">
            {" "}
            <span>Auto Provisioning  | </span> {provision}
          </h1>
          <Row className="row-data-type">
            <div className="data-type">
            <h4>Select provision :</h4>
              <Dropdown
                placeholder="Select provision Type"
                className="drop"
                trigger={['click']}
                menu={{
                  items: provisionList,
                  selectable: true,
                  onClick: handleprovisionClick,
                  selectedKeys: provisionList?.key,
                }}
              >
                <Button className="dropB">
                  <Space className="pixie-datatype">{provision}</Space>
                  <Space>
                    <CaretDownOutlined className="caretIcon" />
                  </Space>
                </Button>
              </Dropdown>
              <h4>Select Job Type :</h4>
              <Dropdown
                placeholder="Select Data Type"
                className="drop"
                trigger={['click']}
                menu={{
                  items: provisionDataTypeList,
                  selectable: true,
                  onClick: handleMenuClick,
                  selectedKeys: datatype?.key,
                }}
              >
                <Button className="dropB">
                  <Space className="pixie-datatype">{dataType}</Space>
                  <Space>
                    <CaretDownOutlined className="caretIcon" />
                  </Space>
                </Button>
              </Dropdown>
              <button
                onClick={() => setViewLogs(true)}
                className="export-btn"
                style={{ marginBottom: "5px" }}
              >
                Job Details
              </button>
            </div>
            <Space className="createR" direction="vertical">
              <Input
                className="search_input"
                prefix={<SearchOutlined size={22} />}
                placeholder="Search by condition..."
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
                allowClear
                style={{
                  maxWidth: "20rem",
                  borderRadius: "10px",
                  border: "1px solid #6BA0FA",
                  marginRight: "1rem",
                }}
              />
            </Space>
          </Row>
          <Row></Row>
          <div className="epms-table-list-falcon tabfalcon">
            <div className="">
              <Row>
                <Col span={24}>
                  <div className="ap-table-style small ">
                    <Table
                      pagination={{
                        ...pagination,
                        onChange: (page, pageSize) => {
                          setPage(page);
                        },
                        showSizeChanger: false,
                      }}
                      loading={loader}
                      size="small"
                      className="ant-pagination  "
                      columns={columns}
                      dataSource={conditionsList?.map((el, idx) => ({
                        key: "userslist" + idx,
                        ...el,
                      }))}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      {viewLogsOpen === true &&
        <JobDetails
          viewLogsOpen={viewLogsOpen}
          handleCloseViewLogs={() => setViewLogs(false)}
          cronJobName={jobName}
          cronJobType={jobType}
          expression={dataType}
          name={''}
        />
      }
    </>
  );
};

export default Falcon;
